import { Image, Text, View, Page, Document, StyleSheet } from '@react-pdf/renderer';
import { formatDate, formatTo0Decimal, getSpecList, isEmpty, isNotEmpty } from '../../common/util.services';
import { LOGO } from '../../common/constants';
import { Fragment } from 'react/jsx-runtime';

const PrintChallan = (props: any) => {
  let challanData = props.data;
  let challanDetail = props.data.challanDetail;
  const styles = StyleSheet.create({
    page: { fontSize: 11, paddingTop: 20, paddingLeft: 40, paddingRight: 40, lineHeight: 1.5, flexDirection: 'column' },
    spaceBetween: { flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', color: "#3E3E3E" },
    titleContainer: { flexDirection: 'row', marginTop: 15 },
    theader: { marginTop: 20, fontSize: 10, fontStyle: 'normal', paddingTop: 4, paddingLeft: 7, flex: 1, fontWeight: 'bold',
               borderColor: 'black', borderWidth: 0.5 },
    theader2: { flex: 3, borderWidth: 0.5, borderColor: 'black' },
    tbody: { fontSize: 9, paddingTop: 4, paddingLeft: 7, flex: 1, borderColor: 'black', borderWidth: 0.5 },
    total: { fontSize: 9, paddingTop: 4, paddingLeft: 7, flex: 1, borderColor: 'black', borderWidth: 0.5 },
    total2: { flex: 3, borderWidth: 0.5, borderColor: 'black' },
    tbody2: { flex: 3, borderWidth: 0.5, borderColor: 'black'}
  });

  function getSpecValue(inputSpec: any, data: any) {
    switch (inputSpec){
      case 'spec1': return data.spec1;
      case 'spec2': return data.spec2;
      case 'spec3': return data.spec3;
      case 'spec4': return data.spec4;
      case 'spec5': return data.spec5;
      case 'spec6': return data.spec6;
      case 'spec7': return data.spec7;
      case 'spec8': return data.spec8;
      case 'spec9': return data.spec9;
      case 'spec10': return data.spec10;
      case 'spec11': return data.spec11;
      case 'spec12': return data.spec12;
      case 'spec13': return data.spec13;
      case 'spec14': return data.spec14;
      case 'spec15': return data.spec15
      default: return '';
    }
  }

  function getSpec(inputSpec: any, type: any, input: any, data: any) {
    let specData = {type: type, input: input};
    let specList = getSpecList(specData);
    let specName = '';
    specList.map((spec: any) => {
      if(inputSpec === spec.fieldObject) {
        specName = spec.fieldName;
      }
    });
    let specValue = getSpecValue(inputSpec, data);
    return isEmpty(specValue) || 'NA' === specValue ? '' : specName + ' - ' + specValue;
  }

  const Header = () => (
    <View style={styles.titleContainer}>
      <View>
        <Image style={{width: 90}} src={LOGO} />
      </View>
      <View style={{position: 'absolute', left: 0, right: 0, alignItems: 'center', justifyContent: 'center', zIndex: -1}}>
        <Text style={{fontSize: 14, textAlign: 'center', fontWeight: 'bold'}}>
          {(challanData.type + ' Challan').toUpperCase()}
        </Text>
      </View>
    </View>
  );

  const InvoiceDetails = () => (
    <View style={styles.titleContainer}>
      <View>
        <Text style={{fontSize: 10, textAlign: 'center', fontWeight: 'bold'}}>{'Challan No.'}</Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>{challanData.challanCode}</Text>
        <Text style={{fontSize: 10, textAlign: 'center', fontWeight: 'bold'}}>Challan Date</Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>{formatDate(challanData.challanDate)}</Text>
        <Text style={{fontSize: 10, textAlign: 'center', fontWeight: 'bold'}}>Supplier Challan</Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>{isNotEmpty(challanData.supplierChallan) ? 
                                                                      challanData.supplierChallan : 'NA'}</Text>
      </View>
      <View>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 100, fontWeight: 'bold'}}>
          {'Material Issue' === challanData.type || 'Sale Issue' === challanData.type ? 'From' : 'To'}</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 100, }}>LFH Home Private Limited</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 100, }}>40-D, Periyar Nagar 2nd Cross</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 100, }}>Sengunthapuram PO, Karur</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 100, }}>Tamil Nadu, 639002</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 100, }}>GSTIN: 33AAECL3320P1ZI</Text>
      </View>
      <View>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 70, fontWeight: 'bold'}}>
          {'Material Issue' === challanData.type || 'Sale Issue' === challanData.type ? 'To' : 'From'}</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 70, }}>{challanData.supplier}</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 70, }}>{challanData.address1}</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 70, }}>{challanData.address2}</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 70, }}>{challanData.address3}</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 70, }}>{'GSTIN: ' + challanData.gstin}</Text>
      </View>
    </View>
  );

  const TransportationDetails = () => (
    <View style={styles.titleContainer}>
      <View>
        <Text style={{fontSize: 10, textAlign: 'center', fontWeight: 'bold'}}>Transporter Details</Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>{'Name: ' + (isEmpty(challanData.transporter) ? 
                                                                      'NA' : challanData.transporter)}</Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>{'GSTIN: ' + (isEmpty(challanData.transporterGstin) ? 
                                                                       'NA' : challanData.transporterGstin)}</Text>
      </View>
      <View>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 100, fontWeight: 'bold'}}>Vehicle Details</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 100}}>{'Number: ' + (isEmpty(challanData.vehicleNumber) ?
                                                                                        'NA' : challanData.vehicleNumber)}</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 100}}>{'Mode: ' + (isEmpty(challanData.vehicleNumber) ?
                                                                                                'NA' : 'Road')}</Text>
      </View>
      <View>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 70, fontWeight: 'bold'}}>Driver Details</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 70}}>{'Name: ' + (isEmpty(challanData.driverName) ?
                                                                                      'NA' : challanData.driverName)}</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 70}}>{'Number: ' + (isEmpty(challanData.driverNumber) ?
                                                                                        'NA' : challanData.driverNumber)}</Text>
      </View>
    </View>
  );

  const TableHead = () => (
    <View style={{ width: '100%', flexDirection: 'row'}}>
      <View style={[styles.theader, styles.theader2]}>
        <Text>Description</Text>
      </View>
      <View style={styles.theader}>
        <Text>Quantity</Text>
      </View>
    </View>
  );

  const TableData1 = () => (//Challan type other than 'Material Issue' or 'Sale Issue'
    <View style={{ width: '100%', flexDirection: 'row' }}>
      <View style={[styles.tbody, styles.tbody2]}>
        <Text style={{fontWeight: "bold"}}>
          {('Material' !== challanData.inputType ? challanData.outputDesc : challanData.inputName) + 
            ' (HSN Code - ' + (isNotEmpty(challanData.hsnCode) ? challanData.hsnCode : 'NA') + ')'}
        </Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{'Code : ' + challanData.inputCode}</Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{'Description : ' + challanData.outputDesc}</Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(challanData.outputDetail) ? 
                                                             'Detail : ' + challanData.outputDetail : ''}</Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{getSpec('spec1', challanData.inputType, challanData.inputName, challanData)}</Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{getSpec('spec2', challanData.inputType, challanData.inputName, challanData)}</Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{getSpec('spec3', challanData.inputType, challanData.inputName, challanData)}</Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{getSpec('spec4', challanData.inputType, challanData.inputName, challanData)}</Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{getSpec('spec5', challanData.inputType, challanData.inputName, challanData)}</Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{getSpec('spec6', challanData.inputType, challanData.inputName, challanData)}</Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{getSpec('spec7', challanData.inputType, challanData.inputName, challanData)}</Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{getSpec('spec8', challanData.inputType, challanData.inputName, challanData)}</Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{getSpec('spec9', challanData.inputType, challanData.inputName, challanData)}</Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{getSpec('spec10', challanData.inputType, challanData.inputName, challanData)}</Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{getSpec('spec11', challanData.inputType, challanData.inputName, challanData)}</Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{getSpec('spec12', challanData.inputType, challanData.inputName, challanData)}</Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{getSpec('spec13', challanData.inputType, challanData.inputName, challanData)}</Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{getSpec('spec14', challanData.inputType, challanData.inputName, challanData)}</Text>
        <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{getSpec('spec15', challanData.inputType, challanData.inputName, challanData)}</Text>
      </View>
      <View style={styles.tbody}>
        <Text>{(isNotEmpty(challanData.quantity) ? formatTo0Decimal(challanData.quantity) : 0) + ' ' + challanData.outputUom}</Text>
      </View>
    </View>
  );

  const TableData2 = () => (//Challan type = 'Material Issue' or 'Sale Issue'
    <Fragment>
      {challanDetail.map((detail: any) => (
        <View style={{ width: '100%', flexDirection: 'row' }}>
          <View style={[styles.tbody, styles.tbody2]} wrap={false}>
            <Text style={{fontWeight: "bold"}}> {detail.serial + '. ' + ('Material' === detail.type ? detail.input : detail.inputCode) +
                                                 ' (HSN Code - ' + (isNotEmpty(detail.hsnCode) ? detail.hsnCode : 'NA') + ')'}</Text>
            {'NA' !== detail.inputCode && <Text style={{marginLeft: 10, fontStyle: 'italic'}}>
              {'Material' !== detail.type ? '' : 'Code : ' + detail.inputCode}</Text>}
            <Text style={{marginLeft: 10, fontStyle: 'italic', fontWeight: 'bold'}}>{'Description : ' + detail.description}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{getSpec('spec1', detail.type, detail.input, detail)}</Text>
            {'Fabric' === detail.input && <Text style={{marginLeft: 10, fontStyle: 'italic'}}>
                                                    {getSpec('spec15', detail.type, detail.input, detail)}
                                                   </Text>}
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{getSpec('spec2', detail.type, detail.input, detail)}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{getSpec('spec3', detail.type, detail.input, detail)}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{getSpec('spec4', detail.type, detail.input, detail)}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{getSpec('spec5', detail.type, detail.input, detail)}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{getSpec('spec6', detail.type, detail.input, detail)}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{getSpec('spec7', detail.type, detail.input, detail)}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{getSpec('spec8', detail.type, detail.input, detail)}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{getSpec('spec9', detail.type, detail.input, detail)}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{getSpec('spec10', detail.type, detail.input, detail)}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{getSpec('spec11', detail.type, detail.input, detail)}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{getSpec('spec12', detail.type, detail.input, detail)}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{getSpec('spec13', detail.type, detail.input, detail)}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{getSpec('spec14', detail.type, detail.input, detail)}</Text>
            {'Fabric' !== detail.input && <Text style={{marginLeft: 10, fontStyle: 'italic'}}>
                                                    {getSpec('spec15', detail.type, detail.input, detail)}
                                                   </Text>}
          </View>
          <View style={styles.tbody}>
            <Text>{formatTo0Decimal(detail.plannedInput) + ' ' + detail.inputUom} </Text>
          </View>
        </View>
      ))}
    </Fragment>
  );

  const OtherText = () => (
    <View style={{ width: '100%', flexDirection: 'row'}}>
      <View wrap={false}>
        <Text style={{fontSize: 10, marginTop: 10, fontStyle: 'italic'}}>- This is a computer generated document and signature is not required</Text>
        <Text style={{fontSize: 10, marginTop: 0, fontStyle: 'italic'}}>- All disputes are subject to Karur jurisdiction</Text>
      </View>
      <View wrap={false}>
        <Text style={{fontSize: 10, marginTop: 25, marginLeft: 110}}>Authorised Signatory</Text>
      </View>
    </View>
  );

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Header/>
        <InvoiceDetails />
        {('Material Issue' === challanData.type || 'Sale Issue' === challanData.type) && <TransportationDetails />}
        <TableHead />
        {('Material Issue' !== challanData.type && 'Sale Issue' !== challanData.type) ? <TableData1 /> : <TableData2 />}
        <OtherText />
      </Page>
    </Document>
  )
}

export default PrintChallan